import { auth_environment } from '../app/core/auth/keycloak/environments/auth.environment.development';
import { captcha_environment } from '../app/core/captcha/environments/captcha.environment.development';

export const environment = {
  auth_environment,
  captcha_environment,
  PRODUCTION: false,
  APP_CODE: 'febacd4d-fb33-40b5-8f19-adccf244a3da',
  X_COUNTRY: 'CL',
  APP_TITLE: 'Portal de Clientes',

  CORPORATE: {
    BUSINESS_DOMAIN: 'SUSCRIPCIÓN',
    BUSINESS_SUBDOMAIN: 'EVALUACIÓN DE RIESGOS',
    BUSINESS_CAPABILITY: 'EVALUACIÓN Y ANÁLISIS DE RIESGOS/CLASIFICACIÓN DE RIESGOS',
    COUNTRY: 'CL',
    CHANNEL: 'WEB',
    APP: 'Portal de Clientes',
  },
  CAPTCHA: {
    DEFAULT_ACTION: 'EFAULT',
    PUBLIC_SINIESTROS_ACTION: 'PUBLIC_SINIESTROS',
    PUBLIC_PATHS: [
      '/v1/public-siniestros',
      '/v1/public/'         // ← cubre cualquier ruta con /public/
    ]
  },
  BFF_BACKEND_URL: 'https://archetype.bff.fidseguros.cl',
  BFF_BACKEND_SERVICE_CSRF: '/bff.service.name/v1/csrf',
  CSRF: {
    COOKIE_NAME: 'XSRF-TOKEN',
    HEADER_NAME: 'X-XSRF-TOKEN',
    COOKIE_DOMAIN: '.fidseguros.cl'
  }
};
